import { toLiteralType, isLiteralType } from '@util/types';

export enum PaidAccessLevel {
    PLUS = 'plus',
    PREMIUM = 'premium',
}

const PAID_ACCESS_LEVELS = Object.values(PaidAccessLevel);

export const isPaidAccessLevel = (str: string): str is PaidAccessLevel => isLiteralType(str, PAID_ACCESS_LEVELS);
export const toPaidAccessLevel = (str: string) => toLiteralType(str, 'paidAccessLevel', PAID_ACCESS_LEVELS);

export const checkPaidAccessLevel = (levelToCheck?: string | null, miniumLevel?: PaidAccessLevel) => {
    if (!levelToCheck) return false;

    switch (miniumLevel) {
        case PaidAccessLevel.PLUS:
            return levelToCheck === PaidAccessLevel.PLUS || levelToCheck === PaidAccessLevel.PREMIUM;
        case PaidAccessLevel.PREMIUM:
            return levelToCheck === PaidAccessLevel.PREMIUM;
        default:
            return isPaidAccessLevel(levelToCheck);
    }
};
